const MIN_LENGTH = 3;
const MAX_LENGTH = 43;
// Allows IPv4, IPv6 addresses, CIDR notation (0-9, a-f, A-F, ., :, /)
const ALLOWED_CHARS = /^[0-9a-fA-F.:/]+$/;

export type IpWhitelistAddressValidationError =
  | 'empty'
  | 'too-short'
  | 'too-long'
  | 'invalid-format';

/**
 * uniqueness checks are still delegated to the backend.
 */
export const validateIpWhitelistAddress = (
  value: string
): IpWhitelistAddressValidationError | null => {
  const v = value.trim();
  if (v.length === 0) return 'empty';
  if (v.length < MIN_LENGTH) return 'too-short';
  if (v.length > MAX_LENGTH) return 'too-long';
  if (!ALLOWED_CHARS.test(v)) return 'invalid-format';
  return null;
};
